export default function AppBar(theme) {
  return {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.secondary.light,
          color: theme.palette.text.primary,
          boxShadow: 'none',
          borderBottom: `1px solid ${theme.palette.grey[200]}`,
          '& .MuiToolbar-root': {
            minHeight: '64px'
          }
        }
      }
    }
  };
} 